import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import localeData from 'dayjs/plugin/localeData'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekday from 'dayjs/plugin/weekday'

import App from './App'
import * as serviceWorker from './serviceWorker'
import { AuthContextProvider } from './middlewares/auth/auth-context'
import LoadingScreen from './components/common/LoadingScreen'

import './i18n'
import './api' // registers the 401 → logout interceptor
import { validTimezone } from '@/utils/DateHelpers'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekday)

// A browser whose own zone name its Intl rejects (Safari, Réunion organizer, Oct 31 2026) would throw in every
// dayjs.tz() call; falling back to UTC keeps the app up. validTimezone also drops unknown stored zones.
const browserTimezone = dayjs.tz.guess
dayjs.tz.guess = () => validTimezone(browserTimezone()) || 'UTC'

// --------------------------------- DISABLED TEMPORARLY
// import 'dayjs/locale/fr'
// import 'dayjs/locale/pt'
const root = createRoot(document.getElementById('root'))

// A data router (one splat route, the app's own <Routes> underneath) so the organizer settings pages
// can block in-app navigation with `useBlocker` while they hold unsaved changes (15 Oct 2026).
const router = createBrowserRouter([
    {
        path: '*',
        element: (
            <AuthContextProvider>
                <App />
            </AuthContextProvider>
        ),
    },
])

root.render(
    <Suspense fallback={<LoadingScreen />}>
        <RouterProvider router={router} />
    </Suspense>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
